import EventTypeNotification from 'domains/models/event_type_notification';
import { z } from 'zod';

export type EventTypeNotificationUpdateBody = z.infer<
  typeof schemaEventTypeNotificationUpdateBody
>;
export const schemaEventTypeNotificationUpdateBody = z.object({
  calendarInviteTitle: z.string().nullable(),
  calendarInviteBody: z.string().nullable(),
  mailConfirmTitle: z.string().nullable(),
  mailConfirmBody: z.string().nullable(),
  mailCancelTitle: z.string().nullable(),
  mailCancelBody: z.string().nullable(),
  mailRemindTitle: z.string().nullable(),
  mailRemindBody: z.string().nullable(),
  mailRemindTiming: z.string().nullable(),
  mailFollowUpTitle: z.string().nullable(),
  mailFollowUpBody: z.string().nullable(),
  mailFollowUpTiming: z.string().nullable(),
  textRemindMessage: z.string().nullable(),
});

export type EventTypeNotificationItem = z.infer<
  typeof schemaEventTypeNotificationItem
>;
export const schemaEventTypeNotificationItem = z.object({
  locale: z.string().nullable(),
  calendarInviteTitle: z.string().nullable(),
  calendarInviteBody: z.string().nullable(),
  mailConfirmTitle: z.string().nullable(),
  mailConfirmBody: z.string().nullable(),
  mailCancelTitle: z.string().nullable(),
  mailCancelBody: z.string().nullable(),
  mailRemindTitle: z.string().nullable(),
  mailRemindBody: z.string().nullable(),
  mailFollowUpTitle: z.string().nullable(),
  mailFollowUpBody: z.string().nullable(),
  textRemindMessage: z.string().nullable(),
});

export const toItem = (
  eventTypeNotification: EventTypeNotification,
): EventTypeNotificationItem => {
  return {
    locale: eventTypeNotification.locale,
    calendarInviteTitle: eventTypeNotification.calendarInviteTitle,
    calendarInviteBody: eventTypeNotification.calendarInviteBody,
    mailConfirmTitle: eventTypeNotification.mailConfirmTitle,
    mailConfirmBody: eventTypeNotification.mailConfirmBody,
    mailCancelTitle: eventTypeNotification.mailCancelTitle,
    mailCancelBody: eventTypeNotification.mailCancelBody,
    mailRemindTitle: eventTypeNotification.mailRemindTitle,
    mailRemindBody: eventTypeNotification.mailRemindBody,
    mailFollowUpTitle: eventTypeNotification.mailFollowUpTitle,
    mailFollowUpBody: eventTypeNotification.mailFollowUpBody,
    textRemindMessage: eventTypeNotification.textRemindMessage,
  };
};

export const schemaTestNotificationMailBody = z.object({
  isMailConfirm: z.boolean().optional(),
  isMailCancel: z.boolean().optional(),
  isMailRemind: z.boolean().optional(),
  isMailFollowUp: z.boolean().optional(),
});

export type TestNotificationMailBody = z.infer<
  typeof schemaTestNotificationMailBody
>;
